import { PosthogEventType } from "@repo/app-types/client/client";
import type { CoachingGoalCondition } from "@repo/app-types/entities/filterConditions";
import { coachingGoalFilterStatusSchema } from "@repo/app-types/entities/filters";
import { getCoachingGoalPillForFilterStatus } from "@repo/app-types/helpers/coachingGoalProgress";
import { CoachingGoalPill } from "@repo/ui/coachingNote/coachingGoalPill";
import { SimpleMenu } from "@repo/ui/Menu/simpleMenu";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import { SimpleMenuPopover } from "@repo/ui/Menu/simpleMenuPopover";
import type { FC } from "react";
import { SubmenuTrigger } from "react-aria-components";
import { useViewerAnalytics } from "../teammate/viewerAnalytics.js";

export interface CoachingGoalFilterOptionProps {
  value: CoachingGoalCondition | null;
  onChange: (newValue: CoachingGoalCondition | null) => void;
}

export const CoachingGoalFilterOption: FC<CoachingGoalFilterOptionProps> = (
  props,
) => {
  // A team-level event: it carries the viewer envelope like the coaching
  // events, but no coaching scope — there is no single coached teammate here.
  const { captureWithViewer } = useViewerAnalytics();

  // If the filter is already set, don't show the option to add another.
  if (props.value !== null) {
    return null;
  }

  return (
    <SubmenuTrigger>
      <SimpleMenuItem>Goal progress</SimpleMenuItem>

      <SimpleMenuPopover>
        <SimpleMenu aria-label="Filter by goal progress">
          {/* One option per pill the Goal progress column can show (minus
              teammates with no goal), rendered as the literal pill so the
              choices look exactly like the values they select. The schema
              options are declared best-standing first, matching the column's
              sort. */}
          {coachingGoalFilterStatusSchema.options.map((status) => (
            <SimpleMenuItem
              key={status}
              onAction={() => {
                props.onChange({ status });
                captureWithViewer(
                  PosthogEventType.TeamPerformanceCoachingGoalFilterApply,
                  { status },
                );
              }}
            >
              <CoachingGoalPill
                pill={getCoachingGoalPillForFilterStatus(status)}
              />
            </SimpleMenuItem>
          ))}
        </SimpleMenu>
      </SimpleMenuPopover>
    </SubmenuTrigger>
  );
};
